import { useCrowdfundingProvider } from '#Context/crowdfunding/Crowdfunding.provider';
import { SetupPeerPageModalFlow } from '#components/organisms/modals/SetupPeerPage/SetupPeerPageModalFlow.js';
import { useShowCampaignById_new, useShowCampaignPeer } from '@givebacks/api/store';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

const ParticipantSetup = () => {
  const { participant_uuid } = useParams();
  const { causeId, campaignId } = useCrowdfundingProvider();
  const navigate = useNavigate();
  const { data: participant, isError: isParticipantError } = useShowCampaignPeer({
    peerType: 'participants',
    peerId: participant_uuid,
    causeId,
    campaignId,
    queryOptions: {
      options: {
        credits: true,
      },
    },
  });

  const { data: campaign, isError: isCampaignError } = useShowCampaignById_new({
    causeId,
    campaignId,
  });

  if (isParticipantError || isCampaignError) {
    return <Navigate to={'..'} />;
  }

  if (!participant || !campaign) return null;
  return (
    <SetupPeerPageModalFlow
      peer={participant}
      campaign={campaign}
      defaultOpen="bannerImage"
      onClose={() => navigate('..')}
    >
      <></>
    </SetupPeerPageModalFlow>
  );
};

export { ParticipantSetup };
